import { DeclarantLanguage, OperatorLanguage } from '../../config/languages'
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react'

interface LanguageOption {
  label: string
  value: DeclarantLanguage | OperatorLanguage
  flag: React.ReactNode
}

export function LanguageSelector({
  languages,
  currentLanguage,
  onChange,
  showLabel = false
}: {
  languages: LanguageOption[]
  currentLanguage: LanguageOption
  onChange: (lang: string) => void
  showLabel?: boolean
}) {
  return (
    <Popover>
      <PopoverButton className="flex items-center gap-2">
        <span className="text-lg">{currentLanguage.flag}</span>
        {showLabel && <span className="text-sm font-medium">{currentLanguage.label}</span>}
      </PopoverButton>
      <PopoverPanel
        transition
        anchor="bottom end"
        className="z-40 min-w-32  transition shadow-dropdown border p-4 border-border-main rounded bg-white duration-200 ease-in-out [--anchor-gap:8px] data-[closed]:-translate-y-1 data-[closed]:opacity-0"
      >
        {({ close }) => (
          <div className="flex flex-col gap-2">
            {languages.map(lang => (
              <button
                className="text-left text-sm font-medium"
                key={lang.value}
                onClick={() => {
                  onChange(lang.value)
                  close()
                }}
              >
                {lang.flag} {lang.label} {lang.value === currentLanguage.value && '✓'}
              </button>
            ))}
          </div>
        )}
      </PopoverPanel>
    </Popover>
  )
}
